import * as React from "react";
import TableStatistics from "widget/orderButtonGroup/tableStatistics";
import { connect } from "react-redux";

interface IOrderStatisticsProps {
  formParam: any;
  statisticsInfo: any;
  infoState: any;
  getOrderListSum: any;
  // 子订单数量，由列表接口提供
  orderTotal: any;
}

// 订单统计
class OrderStatistics extends React.Component<IOrderStatisticsProps, any> {
  constructor(props: IOrderStatisticsProps) {
    super(props);
  }

  componentDidMount() {
    //this.props.getOrderListSum(this.props.formParam);
  }

  getStatisticsInfo = () => {
    const statis = this.props.statisticsInfo;
    let list: any = [];
    if (statis) {
      list = [
        {
          id: this.props.orderTotal || 0,
          name: "子订单"
        },
        {
          id: statis.saleNums || 0,
          name: "数量"
        },
        {
          id: statis.adultNum || 0,
          name: "成人"
        },
        {
          id: statis.childrenNum || 0,
          name: "儿童"
        },
        {
          id: statis.babyNum || 0,
          name: "婴儿"
        }
      ];
    }
    return list;
  };

  render() {
    return (
      <TableStatistics
        className="order-statis"
        statisticsInfo={this.getStatisticsInfo()}
        isLoading={!this.props.infoState}
      />
    );
  }
}

const mapState = state => {
  return {
    statisticsInfo: state.orderInfo.statis.orderData,
    infoState: state.orderInfo.statis.isLoaded
  };
};

const mapDispatch = dispatch => {
  return {
    getOrderListSum: dispatch.orderInfo.getOrderListSum
  };
};

export default connect(
  mapState,
  mapDispatch
)(OrderStatistics);
